import {useState} from 'react';
import {useFocusWithin} from '@react-aria/interactions';

export const usePasswordFieldsFocused = () => {
    const [passwordFocused, setPasswordFocused] = useState(false);
    const [repeatPasswordFocused, setRepeatPasswordFocused] = useState(false);

    const {focusWithinProps: passwordProps} = useFocusWithin({onFocusWithinChange: setPasswordFocused});
    const {focusWithinProps: repeatPasswordProps} = useFocusWithin({onFocusWithinChange: setRepeatPasswordFocused});

    return {passwordFocused, repeatPasswordFocused, passwordProps, repeatPasswordProps};
};
